/**
 * CoolBee Pincode Delivery Estimator
 * Store pincode: 201304 (Noida, Uttar Pradesh)
 * Logic: zone-based delivery days + 1 buffer day, same as Rare Rabbit / Snitch
 */
(function () {
  'use strict';

  const STORE_PINCODE = '201304';

  // Structural + "junk pattern" checks: exactly 6 digits, first digit 1-9,
  // and not an obviously fake pincode (all identical / straight sequence /
  // alternating 2-digit pattern) — mirrors the bulk order form's pincode rules.
  function isValidPincodeFormat(pincode) {
    if (!/^[1-9][0-9]{5}$/.test(pincode)) return false;

    const digits = pincode.split('').map(Number);
    const allSame = digits.every(function (d) { return d === digits[0]; });
    const ascending = digits.every(function (d, i) { return i === 0 || d - digits[i - 1] === 1; });
    const descending = digits.every(function (d, i) { return i === 0 || d - digits[i - 1] === -1; });
    const alternating = digits[0] === digits[2] && digits[2] === digits[4] &&
      digits[1] === digits[3] && digits[3] === digits[5] &&
      digits[0] !== digits[1];

    return !(allSame || ascending || descending || alternating);
  }

  // Returns {min, max} business days based on India postal zone from Noida
  function getDeliveryDays(pincode) {
    if (!isValidPincodeFormat(pincode)) return null;

    const code = parseInt(pincode, 10);
    const prefix3 = Math.floor(code / 1000); // first 3 digits
    const prefix2 = Math.floor(code / 10000); // first 2 digits
    const prefix1 = Math.floor(code / 100000); // first digit

    // Same pincode or immediate Noida area (201xxx)
    if (prefix3 >= 201 && prefix3 <= 203) return { min: 1, max: 2 };

    // Delhi NCR (110xxx, 120xxx-122xxx Gurugram/Faridabad, 131xxx Sonipat)
    if (
      (prefix3 >= 110 && prefix3 <= 110) ||
      (prefix3 >= 120 && prefix3 <= 122) ||
      prefix3 === 131
    ) return { min: 1, max: 2 };

    // Broader UP & Uttarakhand (2xxxxx zone)
    if (prefix1 === 2) return { min: 2, max: 3 };

    // Haryana, Punjab, Himachal, J&K, Chandigarh (1xxxxx zone except Delhi NCR)
    if (prefix1 === 1) return { min: 2, max: 3 };

    // Rajasthan, Gujarat (3xxxxx)
    if (prefix1 === 3) return { min: 3, max: 5 };

    // Maharashtra, Madhya Pradesh, Chhattisgarh (4xxxxx)
    if (prefix1 === 4) return { min: 3, max: 5 };

    // Andhra Pradesh, Telangana, Karnataka (5xxxxx)
    if (prefix1 === 5) return { min: 4, max: 6 };

    // Tamil Nadu, Kerala, Puducherry (6xxxxx)
    if (prefix1 === 6) return { min: 5, max: 7 };

    // West Bengal, Odisha, Assam, NE states (7xxxxx)
    if (prefix1 === 7) return { min: 5, max: 7 };

    // Bihar, Jharkhand (8xxxxx)
    if (prefix1 === 8) return { min: 4, max: 6 };

    // Army Post Offices, remote areas (9xxxxx)
    if (prefix1 === 9) return { min: 5, max: 8 };

    return { min: 4, max: 7 };
  }

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }

  function checkPincode(pincode, resultEl) {
    const days = getDeliveryDays(pincode.trim());
    if (!days) {
      resultEl.innerHTML =
        '<span class="cb-pincode__error">Enter valid pin code</span>';
      return;
    }

    // Add 1 buffer day as requested
    const minDays = days.min + 1;
    const maxDays = days.max + 1;

    const today = new Date();
    const startDate = addDays(today, minDays);
    const endDate = addDays(today, maxDays);

    resultEl.innerHTML =
      '<span class="cb-pincode__success">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="vertical-align:middle;margin-right:4px"><path d="M5 13l4 4L19 7"/></svg>' +
      'Free Delivery, Order now to receive between <strong>' +
      formatDate(startDate) + ' – ' + formatDate(endDate) +
      '</strong></span>';
  }

  function initPincodeWidget(container) {
    const input = container.querySelector('.cb-pincode__input');
    const btn = container.querySelector('.cb-pincode__btn');
    const result = container.querySelector('.cb-pincode__result');
    if (!input || !btn || !result) return;

    // Strip letters/spaces/special characters and cap at 6 digits.
    // The estimate only appears after the customer clicks Check (or presses
    // Enter); editing the pincode clears any previous result.
    input.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 6);
      result.innerHTML = '';
    });

    btn.addEventListener('click', function () {
      checkPincode(input.value, result);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') checkPincode(this.value, result);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cb-pincode-widget').forEach(initPincodeWidget);
  });

  // For dynamically rendered product pages (e.g. after variant change)
  window.cbInitPincodeWidget = initPincodeWidget;
})();
